const SESSION_KEY = 'saloni_order_success_v1';
const LOCAL_KEY = 'saloni_order_success_backup_v1';
const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;

function writePayload(store, payload) {
  try {
    store.setItem(
      store === sessionStorage ? SESSION_KEY : LOCAL_KEY,
      JSON.stringify({
        ...payload,
        placedAt: Date.now(),
      })
    );
  } catch {
    /* ignore quota */
  }
}

export function saveOrderSuccessPayload(payload) {
  writePayload(sessionStorage, payload);
  writePayload(localStorage, payload);
}

/** Recent order placed in this browser session (avoids false “empty bag” after checkout). */
export function readRecentOrderSuccess(maxAgeMs = 5 * 60 * 1000) {
  const payload = readOrderSuccessPayload();
  if (!payload?.orderNumber) return null;
  const placedAt = Number(payload.placedAt) || 0;
  if (placedAt > 0 && Date.now() - placedAt > maxAgeMs) return null;
  return payload;
}

function parseStoredPayload(raw, store, key) {
  if (!raw) return null;
  try {
    const data = JSON.parse(raw);
    const placedAt = Number(data.placedAt) || 0;
    if (placedAt > 0 && Date.now() - placedAt > MAX_AGE_MS) {
      try {
        store.removeItem(key);
      } catch {
        /* ignore */
      }
      return null;
    }
    return data;
  } catch {
    return null;
  }
}

export function readOrderSuccessPayload() {
  try {
    const fromSession = parseStoredPayload(sessionStorage.getItem(SESSION_KEY), sessionStorage, SESSION_KEY);
    if (fromSession) return fromSession;
  } catch {
    /* ignore */
  }
  try {
    return parseStoredPayload(localStorage.getItem(LOCAL_KEY), localStorage, LOCAL_KEY);
  } catch {
    return null;
  }
}

export function clearOrderSuccessPayload() {
  try {
    sessionStorage.removeItem(SESSION_KEY);
  } catch {
    /* ignore */
  }
  try {
    localStorage.removeItem(LOCAL_KEY);
  } catch {
    /* ignore */
  }
}
